import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ThemeContext } from '../context/ThemeContext';
import styles from './LoginPage.module.css';
import { FiEye, FiEyeOff, FiUser, FiLock } from 'react-icons/fi';

const LoginPage = () => {
    const [adminName, setAdminName] = useState('');
    const [adminCode, setAdminCode] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await login(adminName, adminCode);
            navigate('/');
        } catch (err) {
            setError('Invalid administrator credentials. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={`${styles.loginPage} ${styles[theme]}`}>
            <div className={styles.loginCard}>
                <div className={styles.cardHeader}>
                    <h2>Admin Portal</h2>
                </div>

                <form onSubmit={handleSubmit} className={styles.loginForm}>
                    <div className={styles.formGroup}>
                        <label htmlFor="adminName">Admin Username</label>
                        <div className={styles.inputWrapper}>
                            <FiUser className={styles.inputIcon} />
                            <input
                                id="adminName"
                                type="text"
                                value={adminName}
                                onChange={(e) => setAdminName(e.target.value)}
                                placeholder="Enter admin username"
                                required
                                autoComplete="username"
                            />
                        </div>
                    </div>

                    <div className={styles.formGroup}>
                        <label htmlFor="adminCode">Security Code</label>
                        <div className={styles.inputWrapper}>
                            <FiLock className={styles.inputIcon} />
                            <input
                                id="adminCode"
                                type={showPassword ? 'text' : 'password'}
                                value={adminCode}
                                onChange={(e) => setAdminCode(e.target.value)}
                                placeholder="Enter security code"
                                required
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className={styles.passwordToggle}
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className={styles.errorMessage}>
                            {error}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        className={styles.loginButton}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Verifying...' : 'Sign In to Dashboard'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
